// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/index.css
// module id = 245
// module chunks = 0